<script setup>
import { useToast } from "@/composables/useToast";

const { toasts, dismiss } = useToast();

const estilos = {
  ok: "border-ok/25 bg-ok-soft text-ok",
  error: "border-danger/25 bg-danger-soft text-danger",
  info: "border-line bg-surface text-ink-soft",
};
</script>

<template>
  <div
    class="pointer-events-none fixed inset-x-0 top-0 z-[80] flex flex-col items-end gap-2 p-4 sm:p-6"
    aria-live="polite"
  >
    <TransitionGroup name="toast">
      <div
        v-for="t in toasts"
        :key="t.id"
        class="pointer-events-auto flex max-w-sm items-start gap-3 rounded-xl border px-4 py-3 text-sm shadow-sm"
        :class="estilos[t.tipo] || estilos.info"
        role="status"
      >
        <p class="flex-1 leading-snug">{{ t.mensaje }}</p>
        <button
          type="button"
          class="shrink-0 text-current/60 hover:text-current"
          :aria-label="'Cerrar aviso'"
          @click="dismiss(t.id)"
        >
          ×
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.22s ease;
}
.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>
